__turbopack_context__.v({
  "button": "support-form-module-scss-module__FuQaga__button",
  "files_section": "support-form-module-scss-module__FuQaga__files_section",
  "row": "support-form-module-scss-module__FuQaga__row",
  "textarea": "support-form-module-scss-module__FuQaga__textarea",
});
